/**
 * Global recorder activity store.
 *
 * Tracks whether ANY recorder anywhere in the app is currently capturing
 * audio (consulta timer, simulador MediaRecorder, future flows). Consumed
 * by chrome that should hide while recording — e.g. FloatingFeedbackButton —
 * to avoid covering the recorder UI or stealing focus mid-capture.
 *
 * Each recorder owns a unique `id`. `setRecording(id, true)` registers an
 * active session; `setRecording(id, false)` removes it. `isAnyRecording`
 * is `true` whenever the active set is non-empty.
 */

import { create } from "zustand";

interface RecorderState {
  activeIds: ReadonlySet<string>;
  isAnyRecording: boolean;
  setRecording: (id: string, active: boolean) => void;
}

export const useRecorderState = create<RecorderState>((set) => ({
  activeIds: new Set<string>(),
  isAnyRecording: false,
  setRecording: (id, active) =>
    set((state) => {
      const next = new Set(state.activeIds);
      if (active) next.add(id);
      else next.delete(id);
      return { activeIds: next, isAnyRecording: next.size > 0 };
    }),
}));
